module.exports = __webpack_public_path__ + "static/media/iStock-647072096.9a2ef91c.jpg";